import React, {useEffect, useRef, useState} from 'react';
import {View, Platform, Modal, Text} from 'react-native';
import {WebView} from 'react-native-webview';
import {mainSite} from '../config.js';
import {useIsFocused} from '@react-navigation/native';
import {PivotLogging} from '../reducers/cbcLoggingSlice.js';
import {useDispatch} from 'react-redux';
import GameControlBar from './GameControlBar.js';
import Bugsnag from "@bugsnag/expo";
import styled from 'styled-components/native';
import {
    WorkoutsParent,
    WorkoutContainerText,
    WorkoutTextHeader,
    CerebrocoreCommonTextComponent,
    WorkoutContainerHeaderThree,
    WorkoutCommonButton
} from '../styles/common-styles';

function ThirdPartyGameView({gameUrl, endGameCallback}) {

    const dispatch = useDispatch();
    var onLayout;

    const [errorCount, setErrorCount] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [finalErrorModal, setFinalErrorModal] = useState(false);
    const [loadingTimeout, setLoadingTimeout] = useState(null);

    if (Platform.OS == 'web') {
        const [dimensions, setDimensions] = useState({width: 0, height: 0});

        onLayout = (event) => {
            const {width, height} = event.nativeEvent.layout;
            setDimensions({width, height});
        };

        useEffect(() => {
            if (window.parent !== window && dimensions.height >= 150) {
                window.parent.postMessage({
                    height: dimensions.height,
                }, '*');
            }
        }, [dimensions]);
    }

    dispatch(PivotLogging({moduleName: 'ThirdPartyGameView', consoleLog: `${gameUrl}`}));

    const webViewRef = useRef(null);
    const isFocused = useIsFocused();

    useEffect(() => {
        if (isFocused && webViewRef.current) {
            webViewRef.current.reload();
        }
    }, [isFocused]);

    const handleError = (syntheticEvent) => {
        const {nativeEvent} = syntheticEvent;
        setErrorCount(prevErrorCount => prevErrorCount + 1);
        console.log('handleError called');
       
        if (errorCount < 3) {
            // Show a modal indicating that the game failed to load and a retry is underway
            setShowModal(true);
            Bugsnag.notify(`3rd Party Game failed to load after ${errorCount} tries.`);
            setTimeout(() => {
                setShowModal(false);
                webViewRef.current?.reload();
            }, 5000); // Close the modal and retry after 3 seconds
        } else {
            // After 3 failed tries, show a different modal and notify bugsnag
            setFinalErrorModal(true);
            clearTimeout(loadingTimeout);
            Bugsnag.notify('3rd Party Game failed to load after 3, displaying error and returning user to dashboard.');
        }
    };

    const handleLoadStart = () => {
        // Set a timeout of 10 seconds to call handleError function
        console.log('starting timer');
        clearTimeout(loadingTimeout);
        setLoadingTimeout(setTimeout(() => {
            handleError('Loading timeout');
        }, 20000)); // 10 seconds
    };

    const handleLoadEnd = () => {
        // Clear the timeout
        console.log('ending timer');
        clearTimeout(loadingTimeout);
    };

    return Platform.OS === 'web' ? (<>
            <GameControlBar endGameCallback={endGameCallback}/>
            <iframe onLayout={onLayout}
                    src={`${gameUrl}`}
                    height={'95%'}
                    width={'100%'}
            />
        </>) : (<View style={{height: "100%", width: "100%"}}>

            {/* Error modals */}
            <Modal
                animationType="slide"
                transparent={true}
                visible={showModal}
            >
                <ModalViewParent>
                    <ModalView>
                        <WorkoutTextHeader>Error</WorkoutTextHeader>
                        <WorkoutContainerText style={{marginTop: 10}}>We failed to load your exercise, lets try that
                            again.</WorkoutContainerText>
                    </ModalView>
                </ModalViewParent>
            </Modal>

            <Modal
                animationType="slide"
                transparent={true}
                visible={finalErrorModal}
            >
                <ModalViewParent>
                    <ModalView>
                        <WorkoutTextHeader>Error</WorkoutTextHeader>
                        <WorkoutContainerText style={{marginTop: 10}}>We are unable to load your exercise.{'\n'}{'\n'}Please
                            reach out to a developer:</WorkoutContainerText>
                        <Text style={{color: 'blue', marginTop: 10}}
                              onPress={() => Linking.openURL('mailto:support@cerebrocoreusa.com')}
                        >
                            support@cerebrocoreusa.com
                        </Text>
                    </ModalView>
                </ModalViewParent>
            </Modal>

            <GameControlBar endGameCallback={endGameCallback}/>
            <WebView
                ref={webViewRef}
                style={{
                    height: "95%"
                }}
                mixedContentMode='always'
                thirdPartyCookiesEnabled={true}
                sharedCookiesEnabled={true}
                webviewDebuggingEnabled={true}
                onMessage={(event) => {
                    console.log(event.nativeEvent.data);
                }}
                onError={handleError}
                onHttpError={handleError}
                onLoadStart={handleLoadStart}
                onLoadEnd={handleLoadEnd}
                onLoadProgress={({nativeEvent}) => {
                    let loadingProgress = nativeEvent.progress;
                    console.log('Loading progress:' , loadingProgress);
                    handleLoadStart();
                }}
                source={{
                    uri: `${gameUrl}`,
                }}
            />
        </View>);
}


const ModalViewParent = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ModalView = styled.View`
  width: 300px;
  height: auto;
  border-radius: 15px;
  text-align: center;
  padding: 25px;
  background: white;

`

export const ButtonCont = styled.TouchableOpacity`
  height: 35px;
  width: 250px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  margin-top: 15px;
  border:2px solid #3366cc
`

export const ButtonText = styled.Text`
  font-size: 16px;
  color: #3366cc;
`;

export default ThirdPartyGameView;
